export const LOG_LINE_BODY_FIELD_NAME = '___LOG_LINE_BODY___';
export const OTEL_LOG_LINE_ATTRIBUTES_FIELD_NAME = '___OTEL_LOG_ATTRIBUTES___';
